<div class="mt-6 mb-3 md:mb-0 md:mt-0 flex items-center">
  <a class="mr-2" routerLink="/dashboard/wallet/accounts/import">
    <button
      mat-raised-button
      color="primary"
      class="large-btn">
      <span class="flex items-center">
        <span class="mr-2">Import Keystores</span>
        <mat-icon>cloud_upload</mat-icon>
      </span>
    </button>
  </a>
  <a class="ml-1"
    [routerLink]="[ LANDING_URL , 'wallet','accounts','voluntary-exit']">
    <button mat-raised-button
      color="accent"
      class="large-btn ml-1">
      Exit Validators
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </a>
  <a class="ml-3"
    [routerLink]="[ LANDING_URL , 'wallet','accounts','backup']">
    <button mat-raised-button
      color="accent"
      class="large-btn ml-1">
      Back Up Accounts
      <mat-icon>backup</mat-icon>
    </button>
  </a>
  <a class="ml-3">
    <button class="large-btn ml-1" *ngIf="selection?.selected?.length===0"
      color="warn"
      (click)="openDelete()"
      mat-raised-button>Export Slashing Protection</button>
  </a>

  <a class="ml-3">
    <button class="large-btn ml-1" *ngIf="selection?.selected?.length>0"
      color="warn"
      (click)="openDelete()"
      mat-raised-button>Delete Selected Accounts</button>
  </a>
</div>
